import type { InputHTMLAttributes, ReactNode } from 'react';
import type { Path } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';

import Input from 'components/Input/Input';

import ErrorMessage from '../ErrorMessage/ErrorMessage';

type FormInputPropsT<FormValuesT> = InputHTMLAttributes<HTMLInputElement> & {
  name: Path<FormValuesT> | string;
  label?: string | ReactNode;
  isRequired?: boolean;
  icon?: ReactNode;
};

const FormInput = <FormValuesT,>({
  name,
  icon,
  ...restProps
}: FormInputPropsT<FormValuesT>): JSX.Element => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Input {...register(name)} icon={icon} {...restProps} />
      {errors[name] && <ErrorMessage error={errors[name]?.message as Path<FormValuesT>} />}
    </>
  );
};

export default FormInput;
